// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__WA-Tr"};